var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPipesGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 22.6602H15V17.3043C15 16.1837 14.7439 14.9525 14 14.1602C13.2561 13.3678 12.0108 12.6602 10.9587 12.6602H6L6 3.66016H12.1116C13.6738 3.66016 15.2208 3.98811 16.6639 4.62528C18.1071 5.26244 19.4182 6.19632 20.5223 7.37351C21.6264 8.55071 22.5019 9.94815 23.0986 11.4859C23.6953 13.0237 24.0016 14.6717 24 16.3356V22.6602Z",
    fill: "#DCDCE4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.6602V25.6602C14 26.2124 14.4477 26.6602 15 26.6602H24C24.5523 26.6602 25 26.2124 25 25.6602V22.6602C25 22.1079 24.5523 21.6602 24 21.6602H15C14.4477 21.6602 14 22.1079 14 22.6602Z",
    fill: "#AAAAB1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3 13.6602H6C6.55228 13.6602 7 13.2124 7 12.6602L7 3.66016C7 3.10787 6.55228 2.66016 6 2.66016H3C2.44772 2.66016 2 3.10787 2 3.66016L2 12.6602C2 13.2124 2.44772 13.6602 3 13.6602Z",
    fill: "#AAAAB1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.6602C24.3137 13.6602 27 10.9739 27 7.66016C27 4.34645 24.3137 1.66016 21 1.66016C17.6863 1.66016 15 4.34645 15 7.66016C15 10.9739 17.6863 13.6602 21 13.6602Z",
    stroke: "#AAAAB1",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9.66016C22.1046 9.66016 23 8.76473 23 7.66016C23 6.55559 22.1046 5.66016 21 5.66016C19.8954 5.66016 19 6.55559 19 7.66016C19 8.76473 19.8954 9.66016 21 9.66016Z",
    fill: "#AAAAB1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 1.66016H20V13.6602H22V1.66016Z",
    fill: "#AAAAB1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.66016V8.66016H27V6.66016L15 6.66016Z",
    fill: "#AAAAB1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipesGrey);
export default __webpack_public_path__ + "static/media/pipesGrey.509cd3edc916bbc0ead86d6d3d67c7ed.svg";
export { ForwardRef as ReactComponent };